import { keyframes } from "styled-components";

export const fadeVertically = keyframes`
to {
    opacity: 1;
    transform: translateY(0);
}
`;
